import { closeToast, showLoadingToast } from 'vant'
import { backToApp } from 'dad-h5-common-js'
import { showToast } from '@/components/Toast/index.js'
import { showTips } from '@/components/Tips/tips.js'
import { showConfirm } from '@/components/Confirm/confirm.js'

showToast.success = (message, options = {}) => {
  return showToast({ ...options, message, type: 'primary' })
}

showToast.info = (message, options = {}) => {
  return showToast({ ...options, message, type: 'info' })
}

showToast.danger = (message, options = {}) => {
  return showToast({ ...options, message, type: 'danger' })
}

showToast.warning = (message, options = {}) => {
  return showToast({ ...options, message, type: 'warning' })
}

export {
  showToast,
  showTips,
  showConfirm,
}

export function showLoading() {
  closeToast()
  return showLoadingToast({
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0,
  })
}

export { closeToast as hideLoading }

export function errorToBack(msg) {
  showConfirm({
    message: msg,
    showCancelButton: false,
    confirmText: 'Back',
    title: 'opps!',
  }).then((confirmed) => {
    if (confirmed) backToApp()
  })
}
